export default __webpack_public_path__ + "images/a3a3cc6174750231fe120b142b27a67e.svg";